import { BlogPost } from "../types/blog";
import { marked } from "marked";

// Simple frontmatter parser
function parseMd(content: string) {
  const frontmatterRegex = /^---\n([\s\S]*?)\n---\n([\s\S]*)$/;
  const match = content.match(frontmatterRegex);

  if (!match) return { frontmatter: {}, content: content };

  const frontmatter = match[1].split("\n").reduce((acc, line) => {
    const [key, ...value] = line.split(": ");
    if (key && value) acc[key.trim()] = value.join(": ").trim();
    return acc;
  }, {} as Record<string, string>);

  // Convert markdown content to HTML
  const htmlContent = marked(match[2].trim());

  return { frontmatter, content: htmlContent };
}

export async function getAllPosts(): Promise<BlogPost[]> {
  const files = import.meta.glob("../posts/*.md", {
    query: "?raw",
    import: "default",
    eager: true,
  });

  return Object.entries(files)
    .map(([filepath, content]) => {
      const { frontmatter, content: mdContent } = parseMd(content as string);
      const fileName = filepath.split("/").pop() || "";
      const id = fileName.replace(/\.md$/, "");

      return {
        id,
        title: frontmatter.title || id.replace(/-/g, " "),
        content: mdContent,
        author: frontmatter.author || "Anonymous",
        date: frontmatter.date || new Date().toISOString(),
        imageUrl: frontmatter.imageUrl || "",
        excerpt: frontmatter.excerpt || "",
        likes: 0,
        comments: [],
      } as BlogPost;
    })
    .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
}
